import { changeNoteColorMenuText } from './ColorCommandBarButton.locstring.json';
import getChangeColorMenuProps from '../utils/getChangeColorMenuProps';
import { observer } from 'mobx-react';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import * as React from 'react';

const styles = require('./ColorCommandBarButton.scss');

// tslint:disable:prefer-functional-components
@observer
export default class ColorCommandBarButton extends React.Component<any, any> {
    private buttonStyles = {
        root: styles.button,
        label: styles.buttonContent,
        icon: styles.buttonContent,
    };

    private fluentButtonStyles = {
        root: styles.buttonRootFluent,
        label: styles.buttonContent,
        icon: styles.buttonContent,
    };

    render() {
        return (
            <CommandBarButton
                iconProps={{ iconName: 'Color' }}
                split={true}
                styles={
                    isFeatureEnabled('fwk-fluentCommandBar')
                        ? this.fluentButtonStyles
                        : this.buttonStyles
                }
                text={loc(changeNoteColorMenuText)}
                menuProps={{ items: getChangeColorMenuProps() }}
            />
        );
    }
}
